import { render, staticRenderFns } from "./merchants.vue?vue&type=template&id=9e112f34&scoped=true"
import script from "./merchants.vue?vue&type=script&setup=true&lang=ts"
export * from "./merchants.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./merchants.vue?vue&type=style&index=0&id=9e112f34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e112f34",
  null
  
)

export default component.exports